import { Injectable } from '@angular/core';
import { GeneralLedgerTransaction } from '../../financial-statement/models/common/GeneralLedgerTransaction';
import { ValueUtils } from "../../../core/service/value-utils/value-utils.service";

@Injectable({
  providedIn: 'root',
})

export class SortService {

  /* eslint-disable */
  static compareElements(a, b, field: string): number {
    const nestedFields = field.split('.');
    let [lastA, lastB] = [a, b];
    for (const nestedField of nestedFields) {
      lastA = lastA?.[nestedField];
      lastB = lastB?.[nestedField];
    }

    // Sort null or undefined values last
    if (ValueUtils.isValueAbsent(lastA) && ValueUtils.isValueAbsent(lastB)) {
      return 0;
    }
    if (ValueUtils.isValueAbsent(lastA)) {
      return 1; // lastA is null, so it should come after lastB
    }
    if (ValueUtils.isValueAbsent(lastB)) {
      return -1; // lastB is null, so it should come after lastA
    }

    if (typeof lastA === 'string' || typeof lastB === 'string') {
      return (lastB ?? '').toLowerCase().localeCompare((lastA ?? '').toLowerCase());
    }
    return lastA - lastB;
  }
  /* eslint-enable */

  static sortGlTransactions(transactions: GeneralLedgerTransaction[]): GeneralLedgerTransaction[] {
    const sortedTransactions = transactions.sort((a, b) => {
      const timeA = a.transactionDate instanceof Date ? a.transactionDate.getTime() : new Date(a.transactionDate).getTime();
      const timeB = b.transactionDate instanceof Date ? b.transactionDate.getTime() : new Date(b.transactionDate).getTime();
      return timeA - timeB;
    });
    return sortedTransactions;
  }

  static sortGlMapByKey(map: Map<string, GeneralLedgerTransaction[]>): Map<string, GeneralLedgerTransaction[]> {
    const sortedEntries = Array.from(map.entries()).sort(([keyA], [keyB]) => {
      const [quarterA, yearA] = keyA.split(' ');
      const [quarterB, yearB] = keyB.split(' ');
      if (yearA < yearB) return -1;
      if (yearA > yearB) return 1;
      const quarters = ['Q1', 'Q2', 'Q3', 'Q4'];
      const quarterIndexA = quarters.indexOf(quarterA);
      const quarterIndexB = quarters.indexOf(quarterB);
      return quarterIndexA - quarterIndexB;
    });
    const sortedMap = new Map(sortedEntries);
    return sortedMap;
  }

  static sortGlMap(unsortedMap: Map<string, GeneralLedgerTransaction[]>): Map<string, GeneralLedgerTransaction[]> {
    const keySortedMap = this.sortGlMapByKey(unsortedMap);
    keySortedMap.forEach((glArr, _) => {
      const sortedGlArr = SortService.sortGlTransactions(glArr);
      keySortedMap.set(_, sortedGlArr);
    });
    return keySortedMap;
  }
}
